import api from './core';
import { Address, AddressDetail } from './types';

export const getAddresses = async (
  filters?: { site_id?: string | number } | any,
  signal?: AbortSignal
): Promise<Address[]> => {
  // If filters is a React Query context, extract the filter params from the queryKey
  const queryKey = filters?.queryKey;
  const actualFilters = queryKey ? queryKey[1] : filters;
  
  // Note: site_id is now handled via X-Site-ID header in the API request interceptor in core.ts
  // No need to set it explicitly here
  
  const response = await api.get('/crm/addresses/', { signal });
  return response.data;
};

export const getAddress = async (
  id: string | number,
  signal?: AbortSignal
): Promise<AddressDetail> => {
  const response = await api.get(`/crm/addresses/${id}/`, { signal });
  return response.data;
};

export const createAddress = async (data: Partial<Address>): Promise<Address> => {
  const response = await api.post('/crm/addresses/', data);
  return response.data;
};

export const updateAddress = async (id: string, data: Partial<Address>): Promise<Address> => {
  const response = await api.patch(`/crm/addresses/${id}/`, data);
  return response.data;
};

export const deleteAddress = async (id: string): Promise<void> => {
  await api.delete(`/crm/addresses/${id}/`);
};
